import { useState, useRef, useCallback, useEffect } from 'react';

export interface UseAutoHideControlsReturn {
  showControls: boolean;
  handleMouseMove(): void;
}

/** Exibe os controles do Player por 3s após o mouse se mover, depois esconde. */
export function useAutoHideControls(): UseAutoHideControlsReturn {
  const [showControls, setShowControls] = useState(false);
  const hideControlsTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleMouseMove = useCallback(() => {
    setShowControls(true);
    if (hideControlsTimerRef.current) clearTimeout(hideControlsTimerRef.current);
    hideControlsTimerRef.current = setTimeout(() => setShowControls(false), 3_000);
  }, []);

  useEffect(() => () => {
    if (hideControlsTimerRef.current) clearTimeout(hideControlsTimerRef.current);
  }, []);

  return { showControls, handleMouseMove };
}
